import React, { useEffect, useRef, useState, useContext } from "react";
import { ToastContainer, toast } from "react-toastify";
import { CarrierContext } from "../../contexts/CarrierContext";
import { v4 as uuidv4 } from "uuid";
import "react-toastify/dist/ReactToastify.css";
import { postData } from "../../services/guestService";
import { LogContext } from "../../contexts/LogContext";

const EmailToast = ({ data, cms, lastfour }) => {
  //const [email, setEmail] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [case_number, setCaseNumber] = useState("");
  const [dependentNum, setDependentNum] = useState("0");
  const [type_cd, setTypeCd] = useState("");
  const [accountName, setAccountName] = useState("");
  /*const [accountType, setAccountType] = useState("");
  const [last4Digits, setLast4Digits] = useState("");*/

  const emailRef = useRef(null);
  const carrierContxt = useContext(CarrierContext);
  const urlCarrier = carrierContxt.hasOwnProperty("carrier")
    ? carrierContxt.carrier
    : null;
  const carr_code = "REACT_APP_" + urlCarrier.toUpperCase();

  const { Log } = useContext(LogContext);

  const userdata =
    process.env[carr_code] &&
    sessionStorage.getItem("userData_" + process.env[carr_code])
      ? JSON.parse(
          atob(sessionStorage.getItem("userData_" + process.env[carr_code]))
        )
      : "";

  const user = userdata ? userdata.payment_info : "";

  useEffect(() => {
    // Getpayment type(binder/recurring) from userdata
    if (user && user.caseInfo) {
      const caseNum = user.caseInfo[0].caseNum ? user.caseInfo[0].caseNum : "";
      setCaseNumber(caseNum);
    }
    const subscriberFirstName =
      user && user.caseInfo[0].firstName ? user.caseInfo[0].firstName : "";
    const subscriberLastName =
      user && user.caseInfo[0].lastName ? user.caseInfo[0].lastName : "";
    setAccountName(subscriberFirstName + " " + subscriberLastName);
    /*const cim = user && user.caseInfo[0].cim ? user.caseInfo[0].cim : "";  
      setCim(cim);*/
  }, [user]);
  const handleChange = () => {
    //setEmail(emailRef.current.value);
    // console.log(emailRef.current.value, "value")
    // console.log(setEmail, "value of setemail");
    // console.log(email, "email value");
  };

  const validateEmail = (email) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  };
  const sendEmail = (email_id) => {
    const guid = uuidv4();
    let mailSent = false;
    const carr_code_val = process.env[carr_code];
    const email_client_id = "REACT_APP_EMAIL_API_CLIENT_ID_" + carr_code_val;
    const email_client_secret =
      "REACT_APP_EMAIL_API_CLIENT_SECRET_" + carr_code_val;
    const headers = {
      "X-Hps-Trace-Id": guid,
      "X-Hps-Ts": Date.now(),
      "X-Hps-Carrier-Code": process.env[carr_code],
      "X-Hps-Sender-Id": "GUEST PAYMENT PORTAL",
      "X-Hps-SiteCd": process.env[carr_code] + "GPT",
      "X-Hps-Client-Id": process.env[email_client_id],
      "X-Hps-Secret-Id": process.env[email_client_secret],
      "X-Hps-Db-Region": process.env.REACT_APP_REGION,
    };
    const payload = new FormData();
    // Append your form fields to FormData
    //payload.append("case_number", case_number);
    //payload.append("dependent_num", dependentNum); // Assuming dob is a string or formatted date
    //payload.append("email_subject", "Payment Confirmation Email");
    //payload.append("enrollment_id", data?.confirmationCode);
    //payload.append("list_bill_cim", data?.cim);
    //payload.append("account_type", data?.paymentTypeFlag);
    //payload.append("type_cd", process.env[carr_code] + "GPT");
    payload.append("to_address", emailRef?.current.value); // Assuming memberId is a string
    payload.append("payment_amount", data?.amount);
    payload.append("scheduled_date", data?.date);
    payload.append("confirmation_number", data?.confirmationCode);
    payload.append("account_holder_name", accountName);
    payload.append("last_four", lastfour);
    payload.append("payment_method", data?.payment_method);
    payload.append("payment_type", data?.payment_type);
    if (payload) {
      //Combine payload and headers for log API
      // Convert FormData to a plain JavaScript object
      function formDataToObject(formData) {
        const obj = {};
        formData.forEach((value, key) => {
          obj[key] = value;
        });
        return obj;
      }
      // Combine payload and headers
      const combinePayloadAndHeaders = (payload, headers) => {
        const payloadObject = formDataToObject(payload);

        // Combine payload and headers
        const combined = {
          payload: payloadObject,
          headers: headers,
        };

        return JSON.stringify(combined, null, 2); // Pretty print the JSON (optional)
      };
      const request_to_log = combinePayloadAndHeaders(payload, headers);
      const to_email = emailRef.current.value ? emailRef.current.value : "";

      postData(process.env.REACT_APP_EMAIL_API_URL, "", payload, headers)
        .then((result) => {
          if (result) {
            if (result.status && result.data && result.status === 200) {
              const response = result.data;
              if (!response.error) {
                if (response.status_code === "HPS200") {
                  mailSent = true;
                  Log(
                    "EmailSend",
                    "API",
                    case_number,
                    "Email sent successfully",
                    "SUCCESS",
                    request_to_log,
                    result,
                    process.env.REACT_APP_EMAIL_API_URL,
                    "S"
                  );
                }
              } else {
                Log(
                  "EmailSend",
                  "API",
                  case_number,
                  "Email not sent",
                  "ERROR",
                  request_to_log,
                  result,
                  process.env.REACT_APP_EMAIL_API_URL,
                  "F"
                );
              }
            } else {
              Log(
                "EmailSend",
                "API",
                case_number,
                "Email not sent",
                "ERROR",
                request_to_log,
                result,
                process.env.REACT_APP_EMAIL_API_URL,
                "F"
              );
            }
          }
        })
        .catch((error) => {
          let error_msg = "";
          if (error.response) {
            // The request was made and the server responded with a status code
            if (error.response.status === 404) {
              error_msg = cms.err_login_not_found;
            } else {
              error_msg =
                cms.err_login_tech_err +
                " : " +
                error?.response?.status +
                " : " +
                error?.response?.statusText;
            }
          } else if (error.request) {
            // The request was made but no response was received
            error_msg =
              cms.err_login_tech_err +
              " : " +
              error?.request?.status +
              " : " +
              error?.request?.statusText;
          } else {
            // Something happened in setting up the request that triggered an Error
            const errMsg = error.message ? error.message : "";
            error_msg = cms.err_login_tech_err + " : " + errMsg;
          }
          Log(
            "EmailSend",
            "API",
            case_number,
            "Got Exception: Email not sent",
            "ERROR",
            request_to_log,
            error_msg,
            process.env.REACT_APP_EMAIL_API_URL,
            "F"
          );
        })
        .finally(() => {
          if (mailSent) {
            toast.success(`${cms.send_email_success} ${email_id}`);
          } else {
            toast.error(`${cms.send_email_error} ${email_id}`);
          }
        });
    } else {
      //console.log("Email Payload is not set!");
      toast.error(`${cms.send_email_error} ${email_id}`);
    }
  };
  const handleSendEmail = (e) => {
    // Implement the logic for sending email
    e.preventDefault();

    if (validateEmail(emailRef.current.value)) {
      // setEmail("");
      setShowToast(false);
      toast.dismiss();
      sendEmail(emailRef.current.value);
    } else {
      toast.error(cms.invalid_email_id);
    }
  };

  const handleShowToast = () => {
    setShowToast(true);
    //console.log(email, "email123");
    toast(
      () => (
        <div
          className="col-12 px-3"
          role="dialog"
          aria-modal="true"
          aria-labelledby="email-dialog-title"
          aria-describedby="email-dialog-description"
        >
          <h2 id="email-dialog-title" className="visually-hidden">
            {cms.label_send_mail}
          </h2>
          <p id="email-dialog-description" className="visually-hidden">
            {cms.required_mail_id}
          </p>
          <form>
            <div className="form-floating mb-2 border-bottom">
              <input
                type="text"
                className="form-control"
                id="emailInput"
                placeholder={cms.required_mail_id}
                required=""
                style={{ background: "transparent" }}
                ref={emailRef}
                // onChange={handleChange}
              />
              <label htmlFor="emailInput" className="form-label">
                <img
                  src={
                    urlCarrier === "bcbsaz"
                      ? `${process.env.PUBLIC_URL}/images/icons/mail-bcbsaz.svg`
                      : `${process.env.PUBLIC_URL}/images/icons/mail.svg`
                  }
                  className="me-2"
                  alt="Email"
                  width={17}
                  height={17}
                />
                {cms.required_mail_id}
                <span className="text-danger">*</span>
              </label>
            </div>
            <div className="d-grid mt-4 mb-2">
              <input
                type="submit"
                className="btn btn-primary btn-lg"
                value={cms.label_send}
                onClick={handleSendEmail}
              />
            </div>
          </form>
        </div>
        /*<div className="p-3">
          <div className="form-floating mb-2 border-bottom position-relative">
            {/* <h4>Send Confirmation</h4> */
        /* <input
            name='email'
              type="email"
              className="form-control my-2"
              placeholder="Enter Your Email ID"
               ref={emailRef}
               onChange={handleChange}
            /> */
        /*<span className="input-group-append">
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/mail.svg`}
                className="me-2 position-absolute"
                alt="Email"
                width={17}
                height={17}
              />
            </span>
            <input
              // type="text"
              className="form-control"
              name="email "
              type="email"
              // className="form-control my-2"
              placeholder={cms.required_mail_id}
              ref={emailRef}
              onChange={handleChange}
            />*/
        /* <label htmlFor="Email" className="form-label">
                    Email
                </label> */
        /* <label htmlFor="Email" className="form-label">
              {cms.required_mail_id} <span className="text-danger">*</span>
            </label>
          </div>
          <button
            className="btn btn-primary btn-lg"
            /* style={{ width: "100%" }}
            variant="primary"*/
        /*  onClick={handleSendEmail}
          >
            Send
          </button>
        </div>*/
      ),
      {
        autoClose: false,
        onClose: () => setShowToast(false),
        className: "custom-toast", // Add the 'active-toast' class here
        //hideProgressBar: false, // To show the progress bar
        pauseOnHover: true,
        draggable: true,
        //progress: 0.5, // Set progress value (from 0 to 1)
        // position: toast.POSITION.TOP_RIGHT,
        // position: toast.position.t,
        // border: '1px solid red'
      }
    );
    // Wait for the Toast to render inside portal, then focus input
    setTimeout(() => {
      const input = document.getElementById("emailInput");
      if (input) input.focus();
    }, 100); // 100–150ms is ideal for NVDA
  };

  return (
    <>
      <button
        className="btn btn-primary bg-blue btn-send-email btn-lg ms-xl-3 me-xl-3 ms-md-3 me-md-3 button"
        onClick={handleShowToast}
        disabled={showToast}
      >
        {cms.label_send_mail}
      </button>
    </>
  );
};

export default EmailToast;
